module.exports = __webpack_public_path__ + "static/media/courgette.6dc357f9.svg";